import React, { FunctionComponent } from 'react'
import { useParams } from 'react-router-dom'
import styled from 'styled-components'
import { BannerImage } from '../components/banner-image'
import { BlogItemDetail } from '../components/blog-item-detail'
import { ContentContainer } from '../components/content-container'
import { HeadBannar } from '../components/head-bannar'
import { PostNavigator } from '../components/post-navigator'
import { SideBar } from '../components/side-bar'
import { useCategoriesQuery, usePostsQuery } from '../generated/graphql'
import { formatDate } from '../utils/format-date'
import { parseNumberOrNull } from '../utils/parse-number-or-null'
import { isNotNullish } from '../utils/type-check'
import { Inner, SideBarContainer, countByYearMonth, toYearMonth } from './news-list-page'
import { NavigatorContainer, PostContents, PostContentsInner, PostInner } from './news-page'

const Outer = styled.div``

type BlogPageProps = {

}
export const BlogPage: FunctionComponent<BlogPageProps> = () => {
  const params = useParams<'blogId'>()

  const postsQuery = usePostsQuery({variables: {
    first: 100000
  }})
  const categoriesQuery = useCategoriesQuery()

  const targetId = parseNumberOrNull(params.blogId)
  const post = targetId ? postsQuery.data?.posts?.nodes?.find(post => post?.postId === targetId) : null
  const postIndex = postsQuery.data?.posts?.nodes?.indexOf(post) ?? null
  const nextPost = isNotNullish(postIndex) ? postsQuery.data?.posts?.nodes?.[postIndex + 1] ?? null : null
  const prevPost = isNotNullish(postIndex) ? postsQuery.data?.posts?.nodes?.[postIndex - 1] ?? null : null

  return <Outer>
    <HeadBannar desktop={() => <BannerImage src="/images/header_10.jpg" />} mobile={() => <BannerImage src="/images/header_10_mobile.jpg" />}></HeadBannar>
    <ContentContainer>
      <Inner>
        <SideBarContainer>
          <SideBar
            categoryMap={new Map([
              ...categoriesQuery.data?.categories?.nodes?.filter(isNotNullish)
                .map(category => [`/blog?c=${category.slug}`, <span style={{color: category?.fields?.color ?? ''}}>({category.fields?.initial}) {category.name}</span>] as const) ?? []
            ])}
            archiveMap={new Map([
              ...countByYearMonth(postsQuery.data?.posts?.nodes?.map(post => post?.date ? new Date(post.date) : null).filter(isNotNullish) ?? [])
            ])}
            urlGenerator={(time => `/blog?d=${toYearMonth(new Date(time))}`)}
          />
        </SideBarContainer>
        <PostInner>
          {
            post ? <>
              <BlogItemDetail
                title={post.title ?? ''}
                initial={post.categories?.nodes?.[0]?.fields?.initial ?? ''}
                color={post.categories?.nodes?.[0]?.fields?.color ?? ''}
                date={new Date(post.date ?? NaN)}
              />
              <PostContents>
                <PostContentsInner dangerouslySetInnerHTML={{__html: post.content ?? ''}} />
              </PostContents>
            </> :
            '404 Not found'
          }
          {/* <NavigatorContainer>
            <PostNavigator
              prevLink={prevPost ? `/blog/${prevPost.postId}` : null}
              nextLink={nextPost ? `/blog/${nextPost.postId}` : null}
              listLink="/blog"
            />
          </NavigatorContainer> */}
        </PostInner>
      </Inner>
    </ContentContainer>
  </Outer>
}